import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { PORTAL_URL } from '@/config';
import { SITE } from '@/data/site';

export function UtilityBar() {
  return (
    <div className="bg-navy-900 text-[0.875rem] text-on-dark">
      <Container className="flex flex-wrap items-center justify-between gap-x-6 gap-y-1.5 py-2">
        <span className="font-mono text-[0.75rem] tracking-[0.08em] uppercase">Estd. 1941 · Mumbai</span>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-1.5">
          <a href={SITE.phoneHref} className="tap text-on-dark no-underline">{SITE.phone}</a>
          <a href={SITE.emailHref} className="tap text-on-dark no-underline">{SITE.email}</a>
          <AppLink href={PORTAL_URL} className="tap font-semibold text-sky-300 no-underline">
            Staff &amp; institute portal →
          </AppLink>
        </div>
      </Container>
    </div>
  );
}
